// Dependencies
import {
  PERFILES_REQUEST,
  PERFILES_OK,
  PERFILES_REFRESH,
  PERFILES_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PERFILES_REQUEST:
      return { ...state, loading: true };
    case PERFILES_REFRESH:
      return { ...state, refreshing: true };
    case PERFILES_ERROR:
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: action.payload.error,
      };
    case PERFILES_OK:
      return {
        ...state,
        loading: false,
        refreshing: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
